import { GuideRef } from './guide-ref';
import { TimeFilter } from '../components/service-time-filter/time.filter';

export class ServiceFilter {

  public guides?: GuideRef[];
  public categories?: string[];
  public locations?: string[];
  public capacity?: number;
  public languages?: string[];
  public instant?: boolean;
  public accessible?: boolean;
  public petFriendly?: boolean;
  public onlyApprove?: boolean;
  public adultsOnly?: boolean;
  public onlyPublished?: boolean;
  public onlyFeatureTour?: boolean;
  public onlyPending?: boolean;
  public userId?: string;
  public fromDate?: string;
  public toDate?: string;
  public times?: TimeFilter[];
  public cities?: string[];
  public search?: string;

  constructor() {
    this.guides = [];
    this.categories = [];
    this.locations = [];
    this.languages = [];
    this.instant = false;
    this.accessible = false;
    this.petFriendly = false;
    this.onlyApprove = true;
    this.onlyFeatureTour = false;
    this.onlyPublished = true;
    this.adultsOnly = false;
    this.onlyPending = false;
    this.capacity = null;
    this.userId = null;
    this.fromDate = null;
    this.toDate = null;
    this.times = [];
    this.cities = [];
    this.search = '';
  }


  // public addLocationId(id: string): void {
  //     this.locations.push({id: id});
  // }
}
